import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAllCarImagesFolders, selectAllSearchedDealers, selectAllSearchedDealersPreviewTotalCount, selectDealerCriteria, selectSearchFetchingResults } from 'src/app/common/store/state/app.state';
import { DealerCriteria } from 'src/app/public/account/models/dealer-criteria.model';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { FileData } from 'src/app/public/common/models/file-data.model';


@Component({
    selector: 'app-admin-users',
    templateUrl: './admin-users.component.html',
    styleUrl: './admin-users.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminUsersComponent implements OnInit {

  previewTotalCount$: Observable<number>;
  searchCriteria$: Observable<DealerCriteria>;

  fetchingResults$: Observable<boolean>;

  dealerResults$: Observable<Dealer[]>;
  dealerResults: Dealer[] = [];

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  dealerCriteria: DealerCriteria = new DealerCriteria();
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  pageNumbers: number [] = [ 1 ];

  totalItems: number = 0;
  pageSizeOptions = AppConstants.PAGE_SIZE_OPTIONS;

  dealersFetched: boolean = false;
  parameters?: Params;

  constructor(
  
      private store: Store, 
      private route: ActivatedRoute,
      router: Router
      ) {
  
        this.searchCriteria$ = store.select(selectDealerCriteria);
        this.previewTotalCount$ = store.select(selectAllSearchedDealersPreviewTotalCount);
  
        this.fetchingResults$ = store.select(selectSearchFetchingResults);
        this.dealerResults$ = store.select(selectAllSearchedDealers);
        //this.count$ = store.select(selectAllSearchedCarsCount);
  
        this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
  
        this.searchCriteria$.subscribe(criteria => {
          this.dealerCriteria = criteria;
          this.pageSize = this.dealerCriteria.pageSize;
          this.pageNumbers = Array(Math.ceil(this.totalItems/this.dealerCriteria.pageSize)).fill(0).map((x,i)=>i);
        });
    
        route.queryParams.subscribe(params => {
  
          //let temp = JSON.parse(JSON.stringify(params));
          console.log("params = "+JSON.stringify(params));
          this.parameters = params;
  
          //let temp = Object.assign(new DealerCriteria(), params);
          let crt: DealerCriteria = new DealerCriteria();
          AppFunctions.replaceValues(crt, params);
  
          console.log("criteria 1= "+JSON.stringify(crt));
  
          this.store.dispatch(SearchActions.dealerCriteriaSubmit({dealerCriteria: crt}));
  
        });
  
      }
    
      ngOnInit() {
  
        this.previewTotalCount$.subscribe(total => {
          this.totalItems = total;
          //this.pageNumbers = Array(Math.ceil(this.totalItems/this.dealerCriteria.pageSize)).fill(0).map((x,i)=>i);
        });
  
        if(!this.dealersFetched){
          
          //let crt: DealerCriteria = JSON.parse(JSON.stringify(this.dealerCriteria));
          let crt: DealerCriteria = new DealerCriteria();
          AppFunctions.replaceValues(crt, this.parameters);
  
          console.log("criteria 22 = "+JSON.stringify(crt));
          this.store.dispatch(SearchActions.dealerCriteriaSubmit({dealerCriteria: crt}));
          this.dealersFetched = true;
  
        } 
    
        this.dealerResults$.subscribe(
          (res: Dealer[]) =>  {
            this.dealerResults = res.map(c => Object.assign(new Dealer(), c));
          }
        );
    }

    updateDealer(dealer: Dealer) {
      
      console.log(dealer)
      this.store.dispatch(DealerActions.updateDealerProfileSubmit({dlUpdates: dealer}));
    }

    deleteDealer(dealer: Dealer) {
      console.log(dealer)
    }
    
}
